'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreXGamingLimitType = exports.CoreXLimitStatus = exports.CoreXLimitType = exports.CoreXLimitDuration = void 0;
var CoreXLimitDuration;
(function (CoreXLimitDuration) {
    CoreXLimitDuration["TWO_MINUTES"] = "PT2M";
    CoreXLimitDuration["TWO_HOURS"] = "PT2H";
    CoreXLimitDuration["FIVE_HOURS"] = "PT5H";
    CoreXLimitDuration["TEN_HOURS"] = "PT10H";
    CoreXLimitDuration["FIFTEEN_HOURS"] = "PT15H";
    CoreXLimitDuration["ONE_DAY"] = "P1D";
    CoreXLimitDuration["ONE_WEEK"] = "P7D";
    CoreXLimitDuration["ONE_MONTH"] = "P30D";
    CoreXLimitDuration["NO_DURATION"] = "";
})(CoreXLimitDuration = exports.CoreXLimitDuration || (exports.CoreXLimitDuration = {}));
var CoreXLimitType;
(function (CoreXLimitType) {
    CoreXLimitType["LOSS"] = "Loss";
    CoreXLimitType["WAGERING"] = "Wagering";
    CoreXLimitType["DEPOSIT"] = "Deposit";
    CoreXLimitType["NET_DEPOSIT"] = "NetDeposit";
    CoreXLimitType["WITHDRAWAL"] = "Withdrawal";
    CoreXLimitType["SESSION"] = "Session";
    CoreXLimitType["MAX_WAGER"] = "Max Wager";
})(CoreXLimitType = exports.CoreXLimitType || (exports.CoreXLimitType = {}));
var CoreXLimitStatus;
(function (CoreXLimitStatus) {
    CoreXLimitStatus["PENDING_ACTIVATION"] = "PendingActivation";
    CoreXLimitStatus["ACTIVE"] = "Active";
    CoreXLimitStatus["PENDING_CANCELLATION"] = "PendingCancellation";
    CoreXLimitStatus["CANCELLED"] = "Canceled";
    CoreXLimitStatus["PENDING_USER_ACTION"] = "PendingUserAction";
})(CoreXLimitStatus = exports.CoreXLimitStatus || (exports.CoreXLimitStatus = {}));
var CoreXGamingLimitType;
(function (CoreXGamingLimitType) {
    CoreXGamingLimitType[CoreXGamingLimitType["DEPOSIT"] = 1] = "DEPOSIT";
    CoreXGamingLimitType[CoreXGamingLimitType["WAGERING_CASINO"] = 2] = "WAGERING_CASINO";
    CoreXGamingLimitType[CoreXGamingLimitType["LOSS_CASINO"] = 3] = "LOSS_CASINO";
    CoreXGamingLimitType[CoreXGamingLimitType["WAGERING_SPORTS"] = 4] = "WAGERING_SPORTS";
    CoreXGamingLimitType[CoreXGamingLimitType["LOSS_SPORTS"] = 5] = "LOSS_SPORTS";
    CoreXGamingLimitType[CoreXGamingLimitType["SESSION"] = 6] = "SESSION";
    CoreXGamingLimitType[CoreXGamingLimitType["WITHDRAWAL"] = 7] = "WITHDRAWAL";
    CoreXGamingLimitType[CoreXGamingLimitType["MAX_WAGER_CASINO"] = 8] = "MAX_WAGER_CASINO";
    CoreXGamingLimitType[CoreXGamingLimitType["MAX_WAGER_SPORTS"] = 9] = "MAX_WAGER_SPORTS";
    CoreXGamingLimitType[CoreXGamingLimitType["NET_DEPOSIT"] = 11] = "NET_DEPOSIT";
})(CoreXGamingLimitType = exports.CoreXGamingLimitType || (exports.CoreXGamingLimitType = {}));
